<template>
  <div id="app">
    <Navbar v-if="isNav"/>
    <router-view></router-view>
  </div>
</template>

<script>
	import Navbar from "@/components/navbar";

	export default {
		name : "app",
		components : {
			Navbar
		},
    data(){
			return {
				isNav : true
      }
    },
		watch : {
			'$route.path' : function (o, n){
				if( o.indexOf("antiCorruptionReport") > 0){
					this.isNav = false
        } else this.isNav = true
			}
		}
	};
</script>

<style lang="less">
  @import "~@/styles/normalize.less";

  body,
  html {
    width: 100%;
    height: 100%;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    font-size: 16px;
    line-height: 1.4;
  }

  @media screen and (min-width: 767px) {
    html,
    #app {
      font-size: 16px !important;
    }
  }

  @media screen and (max-width: 767px) {
    html,
    #app {
      font-size: 18px !important;
    }

    .navbar #logo img {
      width: 133px;
    }
  }

  @media screen and (min-width: 400px)  and (max-width: 480px) {
    html, #app {
      font-size: 16px !important;
    }
  }

  @media screen and (min-width: 321px) and (max-width: 400px) {
    html, #app {
      font-size: 16px !important;
    }
  }

  @media screen and (max-width: 321px) {
    html, #app {
      font-size: 11px !important;
    }
  }

</style>


<!--<template>-->
<!--<div class="body-item" style="z-index:1;">-->
<!--<nva></nva>-->
<!--<div class="body-item">-->
<!--<div class="nav-floor">-->
<!--<div class="fl-item pre" @click="prePage"><</div>-->
<!--<div class="fl-item" @click="optCurrent(1)">01</div>-->
<!--<div class="fl-item" @click="optCurrent(2)">02</div>-->
<!--<div class="fl-item" @click="optCurrent(3)">03</div>-->
<!--<div class="fl-item next" @click="nextPage"><</div>-->
<!--</div>-->
<!--<div class="body-item ">-->
<!--<slider ref="slider" :options="options">-->
<!--<slideritem v-for="(item,index) in someList" :key="index" :style="item.style">-->
<!--<div class="body-item " v-if="current===1">-->
<!--<HelloWorld></HelloWorld>-->
<!--</div>-->
<!--<div class="body-item " v-if="current===2">-->
<!--{{item.html}}-->
<!--</div>-->
<!--<div class="body-item " v-if="current===3">-->
<!--{{item.html}}-->
<!--</div>-->
<!--</slideritem>-->
<!--</slider>-->
<!--</div>-->
<!--<div class="guide-box">-->
<!--<div class="guide">-->
<!--<div class="guide-scale"></div>-->
<!--<div class="guide-pre"></div>-->
<!--<div class="guide-s"></div>-->
<!--<div class="guide-next"></div>-->
<!--</div>-->
<!--</div>-->
<!--</div>-->
<!--</div>-->
<!--</template>-->
<!--<style>-->
<!--body,html{-->
<!--width: 100%;-->
<!--height: 100%;-->
<!--padding:0;-->
<!--margin: 0;-->
<!--}-->
<!--.body-item{-->
<!--width:100%;-->
<!--margin:0px auto;-->
<!--height:100%;-->
<!--position: relative;-->
<!--color: black;-->
<!--}-->
<!--.nav-floor{-->
<!--z-index: 999;-->
<!--position: fixed;-->
<!--top: calc(50% - 60px);-->
<!--background: transparent;-->
<!--width: 30px;-->
<!--min-height: 100px;-->
<!--left:10%;-->
<!--}-->
<!--.nav-floor .fl-item{-->
<!--width: 100%;-->
<!--height: 30px;-->
<!--text-align: center;-->
<!--line-height: 30px;-->
<!--cursor: pointer;-->
<!--}-->
<!--.nav-floor .fl-item.pre{-->
<!--transform: rotate(90deg);-->
<!--}-->
<!--.nav-floor .fl-item.next{-->
<!--transform: rotate(-90deg);-->
<!--}-->
<!--.guide-box{-->
<!--z-index: 999;-->
<!--position: fixed;-->
<!--bottom: 30px;-->
<!--height: 70px;-->
<!--width: 100%;-->
<!--}-->
<!--.guide-box .guide{-->
<!--margin: 0 auto;-->
<!--width: 25px;-->
<!--height: 50px;-->
<!--background: transparent;-->
<!--border-radius: 20px;-->
<!--border:2px solid #fff;-->
<!--position: relative;-->
<!--}-->
<!--.guide-scale{-->
<!--width: 25px;-->
<!--height: 50px;-->
<!--border-radius: 20px;-->
<!--border:2px solid #fff;-->
<!--position: absolute;-->
<!--top: -2px;-->
<!--left: -2px;-->
<!--animation: myfirst 1.5s  infinite;-->
<!--}-->
<!--.guide-s{-->
<!--width: 4px;-->
<!--height: 6px;-->
<!--background: #fff;-->
<!--position: absolute;-->
<!--top: 8px;-->
<!--left: 10px;-->
<!--border-radius: 2px;-->
<!--}-->
<!--.guide-next{-->
<!--width: 0;-->
<!--height: 0;-->
<!--border: 4px solid;-->
<!--border-color: transparent transparent #fff;-->
<!--transform: rotate(-180deg);-->
<!--position: absolute;-->
<!--bottom: -18px;-->
<!--left: 8px;-->
<!--}-->
<!--.guide-pre{-->
<!--width: 0;-->
<!--height: 0;-->
<!--border: 4px solid;-->
<!--border-color: transparent transparent #fff;-->
<!--position: absolute;-->
<!--top: -16px;-->
<!--left: 8px;-->
<!--}-->

<!--@keyframes myfirst{-->
<!--0% {transform: scale(1);opacity: 1;}-->
<!--100% {transform: scale(1.2);opacity: 0;}-->
<!--}-->

<!--</style>-->
<!--<script>-->
<!--import { slider, slideritem } from 'vue-concise-slider'// import slider components-->
<!--import HelloWorld from "./common/HelloWorld"-->
<!--import nva from "./common/nva"-->
<!--export default {-->
<!--data () {-->
<!--return {-->
<!--current:0,-->
<!--fl_top:0,-->
<!--someList:[-->
<!--{-->
<!--html: 'slide1',-->
<!--style: {-->
<!--'background': '#1bbc9b'-->
<!--}-->
<!--},-->
<!--{-->
<!--html: 'slide2',-->
<!--style: {-->
<!--'background': '#c32f1f'-->
<!--}-->
<!--},-->
<!--{-->
<!--html: 'slide3',-->
<!--style: {-->
<!--'background': '#212cbe'-->
<!--}-->
<!--}-->
<!--],-->
<!--options: {-->
<!--pagination: false,-->
<!--currentPage: 0,-->
<!--thresholdDistance:500,-->
<!--thresholdTime:100,-->
<!--// autoplay:10000,-->
<!--// loop: true,-->
<!--direction:'vertical',-->
<!--loopedSlides:1,-->
<!--slidesToScroll:1,-->
<!--timingFunction: 'ease',-->
<!--speed: 300-->

<!--// pagination: true, // 底部小圆点是否隐藏（true显示，false隐藏）-->
<!--// currentPage: 0, // 当前页码-->
<!--// thresholdDistance:500, // 滑动判定距离-->
<!--// thresholdTime:100, // 滑动判定时间-->
<!--// autoplay:2000, // 自动滚动[ms]-->
<!--// loop:true, // 是否循环滚动-->
<!--// direction:'vertical', // 滚动方向-->
<!--// infinite:1, // 无限滚动前后遍历数-->
<!--// slidesToScroll:1, // 滚动行数-->
<!--}-->
<!--}-->
<!--},-->
<!--components: {-->
<!--slider,-->
<!--slideritem,-->
<!--nva,-->
<!--HelloWorld-->
<!--},-->
<!--mounted () {-->
<!--window.addEventListener('mousewheel',this.handleScroll,false)-->
<!--window.addEventListener("DOMMouseScroll",this.handleScroll,false);-->
<!--},-->
<!--methods: {-->
<!--handleScroll (e) {-->
<!--var direction = e.deltaY>0?'down':'up' //该语句可以用来判断滚轮是向上滑动还是向下-->
<!--if(direction==='down'){-->
<!--this.current = (this.current+1)<4?(this.current+1):3-->
<!--this.$refs.slider.$emit('slideNext')-->
<!--}else{-->
<!--this.current =  (this.current-1)>0?(this.current-1):1-->
<!--this.$refs.slider.$emit('slidePre')-->
<!--}-->
<!--},-->
<!--prePage(){-->
<!--this.$refs.slider.$emit('slidePre')-->
<!--},-->
<!--nextPage(){-->
<!--this.$refs.slider.$emit('slideNext')-->
<!--},-->
<!--optCurrent (data) {-->
<!--this.current = data-->
<!--this.$refs.slider.$emit('slideTo', data-1)-->
<!--},-->

<!--// Listener event-->
<!--slide (data) {-->
<!--console.log(data)-->
<!--},-->
<!--onTap (data) {-->
<!--console.log(data)-->
<!--},-->
<!--onInit (data) {-->
<!--console.log(data)-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
